import { AxiosError } from "axios";

import { NormalText } from "@/components/text/NormalText";
import { ToastSupportFooter } from "@/components/ToastSupportFooter";

export function ErrorToastContent({
  error,
}: {
  error: AxiosError | Error;
}): React.ReactNode {
  return (
    <div>
      <NormalText elementType="p" className="font-bold">
        An error occurred!
      </NormalText>
      <NormalText elementType="p">
        {"message" in error && error.message}
        {"code" in error && (
          <NormalText elementType="span" className="ml-1 font-mono text-xs">
            ({error.code})
          </NormalText>
        )}
      </NormalText>
      <ToastSupportFooter lead="If the problem persists, please" />
    </div>
  );
}
